import React from 'react'
import {Hotel} from '@findhotel/sapi'
import {BoVioFirstOffer} from 'components/Offer/BoVioFirst'
import {PrimaryOffer} from 'components/Offer/Primary'
import {UnavailabilityWithChangeDates} from 'components/Unavailability/UnavailabilityComponent/UnavailabilityWithChangeDates'
import {useBoVioFirstOfferContainer} from 'hooks/useBoVioFirstOfferContainer'

import {Box} from '@vio/atlas/helpers/Box'

interface Props {
  hotelId: Hotel['objectID']
  isAnchor: boolean
  onChangeDatesClick: (event: React.MouseEvent) => void
  onClick: (sourceComponent: string) => void
}
export const BoVioFirstOfferDetails: React.FC<Props> = ({
  hotelId,
  isAnchor,
  onChangeDatesClick,
  onClick
}) => {
  const {
    isSoldOut,
    isLoading,
    primaryOffer,
    cheapestOfferFromOthers,
    offerVariant,
    otherOffersMetadata,
    onOfferClick,
    isOTAMode,
    hasPrimarySplitBookingOffer,
    splitBookingOffers,
    splitBookingBundle
  } = useBoVioFirstOfferContainer({hotelId, isAnchor, onClick})

  if (isSoldOut) {
    return (
      <Box padding="s400">
        <UnavailabilityWithChangeDates
          hasCompactButton
          handleChangeDatesClick={onChangeDatesClick}
        />
      </Box>
    )
  }

  if (isLoading)
    return (
      <Box padding="s400">
        <BoVioFirstOffer isLoading isOTAMode={isOTAMode} />
      </Box>
    )

  if (hasPrimarySplitBookingOffer)
    return (
      <Box padding="s400">
        <PrimaryOffer
          isSplitBooking
          variant="PrimaryMultiColumn"
          hotelId={hotelId}
          splitBookingOffers={splitBookingOffers}
          splitBookingBundle={splitBookingBundle}
          shouldShowTaxationAndNightly
          showProviderLogo={!isOTAMode}
          showCta={false}
          sourceComponent="BoVioFirstOfferDetails"
        />
      </Box>
    )

  return (
    <Box onClick={onOfferClick} padding="s400">
      <BoVioFirstOffer
        sourceComponent="BoVioFirstOfferDetails"
        hotelId={hotelId}
        primaryOffer={primaryOffer}
        cheapestOfferFromOthers={cheapestOfferFromOthers}
        otherOffersMetadata={otherOffersMetadata}
        offerVariant={offerVariant}
        isOTAMode={isOTAMode}
      />
    </Box>
  )
}
